import React from 'react';
import PropTypes from 'prop-types';
import fr from 'facet-rest';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';
import { noop } from 'Helpers/PropTypes';
import {
  ReactionItem,
} from 'Components/ComponentLibrary/Components/Uncategorized/ReactionList/components/ReactionItem';
import {
  AddReactionButton,
} from 'Components/ComponentLibrary/Components/Uncategorized/ReactionList/components/AddReactionButton';
import { useTheme, buildUseStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';

const useStyles = buildUseStyles('ReactionList', (theme) => ({
  root: {
    display: 'flex',
    gap: theme.spacing(0.5),
    marginTop: theme.spacing(0.5),
  },
}));

const ReactionList = ({
  reactions,
  onAddReaction,
  onRemoveReaction,
}) => {
  const theme = useTheme();
  const classes = useStyles(theme);

  return (
    <Box className={classes.root}>
      {reactions.map(reaction => (
        <ReactionItem
          key={reaction.emoji}
          reaction={reaction}
          onAddReaction={() => onAddReaction(reaction.emoji)}
          onRemoveReaction={() => onRemoveReaction(reaction)}
        />
      ))}
      <AddReactionButton handleAdd={(emoji) => onAddReaction(emoji)} />
    </Box>
  );
};

ReactionList.defaultProps = {
  onAddReaction: noop,
  onRemoveReaction: noop,
};

ReactionList.propTypes = {
  // reactions: An array of reaction resources passed individually into ReactionItem
  reactions: PropTypes.arrayOf(PropTypes.shape(
    {
      emoji: PropTypes.string,
      count: PropTypes.number,
      owners: PropTypes.arrayOf(PropTypes.string),
      isSelected: PropTypes.bool,
      myReactionResource: PropTypes.instanceOf(fr.Resource),
    },
  )).isRequired,
  // onAddReaction: callback to run if a reaction is added
  onAddReaction: PropTypes.func,
  // onRemoveReaction: callback to run if a reaction is removed
  onRemoveReaction: PropTypes.func,
};

export { ReactionList };
